export default __webpack_public_path__ + "img/busqueda.7b8c47e4.svg";